export const UPLOAD_PACKAGE = "PACKAGES/UPLOAD";

export const uploadPackage = (uploadData) => ({
	type: UPLOAD_PACKAGE,
	payload: {
		uploadData,
	},
});
